import yup from "@/yup";

export function useUserUpdateSchema() {
  return yup.object({
    password: yup
      .string()
      .min(6)
      .transform((value) => (!value ? undefined : value)),
    autoEnableGames: yup
      .boolean()
      .optional()
      .transform((value) => {
        return value === undefined || value === null ? undefined : value;
      }),
    lobbySettings: yup.object({
      isPanicEnabled: yup.boolean(),
      panicUrl: yup.string().url(),
    }),
    cashierSettings: yup
      .object({ isShortPlayerCreation: yup.boolean() })
      .optional()
      .transform((value) => {
        if (!value) {
          return value;
        }
        return Object.keys(value).length === 0 ? undefined : value;
      })
      .default(undefined),
  });
}

export type TUserUpdateSchema = yup.InferType<
  ReturnType<typeof useUserUpdateSchema>
>;
